'use client';

import * as React from 'react';
import { styled } from '@linaria/react';

interface Props {
  children: React.ReactNode;
}

function ClickToReveal({ children }: Props) {
  const [isRevealed, setIsRevealed] = React.useState(false);

  return (
    <Wrapper data-is-revealed={isRevealed}>
      <ChildWrapper>{children}</ChildWrapper>
      {!isRevealed && (
        <Button onClick={() => setIsRevealed(true)}>
          Click to show
        </Button>
      )}
    </Wrapper>
  );
}

const Wrapper = styled.div`
  position: relative;
  overflow: hidden;
  margin-top: 0.5rem;
  margin-bottom: 2rem;

  &[data-is-revealed='false'] {
    border-radius: 8px;
    border: 1px solid var(--color-gray-300);
  }
`;

const ChildWrapper = styled.div`
  position: relative;
  filter: blur(30px);
  transition: filter 400ms;

  ${Wrapper}[data-is-revealed='true'] & {
    filter: blur(0px);
  }
`;

const Button = styled.button`
  position: absolute;
  inset: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.125rem;
  font-weight: var(--font-weight-medium);
  border-radius: 4px;
  text-shadow:
    0px 1px 2px var(--color-background),
    0px 3px 6px var(--color-background);
`;

export default ClickToReveal;
